import React from 'react';
import PuzzleTopBar from '../shared/PuzzleTopBar';
import { PuzzleNames } from '../../../utils/types';
import { Pathword5x5Store } from './Pathword5x5Store';
import { onReveal, onSolve, savePathword5x5 } from './pathword5x5utils';
import Instructions from './components/Instructions';
import PathwordGrid from '../Pathword/components/PathwordGrid';
import { useAmplitudeTracking, useFirstTimeInstructions, usePageVisibilityPause, useStructuredDataEmbedding } from '../shared/utils';
import PauseCover from '../shared/PauseCover';
import AlmostThereDialog from '../Pathword/components/AlmostThereDialog';
import { usePuzzleTracking } from '../../../utils/usePuzzleTracking';

const Pathword5x5 = () => {
  useFirstTimeInstructions(PuzzleNames.Pathword5x5, Pathword5x5Store as any);
  usePageVisibilityPause(Pathword5x5Store as any, savePathword5x5);
  useStructuredDataEmbedding(PuzzleNames.Pathword5x5);
  useAmplitudeTracking(PuzzleNames.Pathword5x5);
  usePuzzleTracking(PuzzleNames.Pathword5x5);

  return (
    <>
      <PuzzleTopBar
        puzzleName={PuzzleNames.Pathword5x5}
        store={Pathword5x5Store as any}
        onReveal={onReveal}
        onSave={savePathword5x5}
        InstructionsComponent={Instructions}
      />
      <AlmostThereDialog/>
      <div className="puzzleContainer pathwordContainer pathword5x5Container">
        <PathwordGrid store={Pathword5x5Store} onSolve={onSolve}/>
        <PauseCover store={Pathword5x5Store as any}/>
      </div>
    </>
  )
};

export default Pathword5x5;